import { render, staticRenderFns } from "./CardHeadPrice.vue?vue&type=template&id=bac89416&scoped=true&"
import script from "./CardHeadPrice.vue?vue&type=script&lang=js&"
export * from "./CardHeadPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac89416",
  null
  
)

export default component.exports